export const READY_ORDER_ATTENTION_DURATION_MS = 5600;

const READY_ORDER_ATTENTION_CHANNELS = new Set(['balcao', 'salao']);

const normalizeStatus = (value) => String(value || '').trim().toLowerCase();

export const getReadyOrderAttentionKey = (channelKey, orderId) => {
  const channel = String(channelKey || '').trim().toLowerCase();
  const id = String(orderId || '').trim();
  return channel && id ? `${channel}:${id}` : '';
};

export const detectVerifiedReadyOrderTransitions = ({
  channelKey,
  channel,
  previousStatusById = new Map(),
  hydrated = false,
} = {}) => {
  if (!READY_ORDER_ATTENTION_CHANNELS.has(channelKey) || !channel?.verified) {
    return { nextStatusById: previousStatusById, transitionedOrderKeys: [] };
  }

  const nextStatusById = new Map();
  const transitionedOrderKeys = [];

  (channel.orders || []).forEach((order) => {
    const orderId = String(order?.orderId || '').trim();
    if (!orderId) return;
    const status = normalizeStatus(order.status);
    const previousStatus = previousStatusById.get(orderId);
    nextStatusById.set(orderId, status);

    if (hydrated && previousStatus && previousStatus !== 'ready' && status === 'ready') {
      transitionedOrderKeys.push(getReadyOrderAttentionKey(channelKey, orderId));
    }
  });

  return { nextStatusById, transitionedOrderKeys };
};
